import React from 'react'
import { capitalCase } from 'change-case'
import ReactSelect from 'react-select'
import SortIcon from '@mui/icons-material/Sort'

interface Props {
  sortProp: string
  setSortProp: SetState<string>
  sortDirection: string
  setSortDirection: SetState<string>
}

const sortOptions = ['createdTime', 'updatedTime', 'name', 'startTime', 'endTime', 'goal'].map(
  value => ({ label: capitalCase(value), value })
)

export const CampaignFiltersPanel = (props: Props) => (
  <div>
    <p className="mb-1 text-xs font-semibold text-mm-neutral-1-600">Sort</p>
    <div className="flex">
      <div className="flex-1">
        <ReactSelect
          value={sortOptions.find(o => o.value === props.sortProp)}
          options={sortOptions}
          onChange={(newValue: any) => newValue && props.setSortProp(newValue.value)}
          openMenuOnClick
        />
      </div>
      <button
        type="button"
        onClick={() => props.setSortDirection(d => (d === 'ASC' ? 'DESC' : 'ASC'))}
        className="-ml-px flex flex-shrink-0 items-center space-x-2 rounded-r-md border border-mm-neutral-1-300 bg-mm-neutral-1-50 px-2 py-2 text-sm font-medium text-mm-neutral-1-700 hover:bg-mm-neutral-1-100"
      >
        <SortIcon className="h-5 w-5 text-mm-neutral-1-400" />
        <span>{props.sortDirection}</span>
      </button>
    </div>
  </div>
)
